import { useEffect } from 'react';

import { SessionNoteSignatures } from '../../../../constants';

import type { UseGuardianVerificationLifecycleParams } from './types';

export const useGuardianVerificationLifecycle = ({
  signatureStep,
  setSelectedParentEmail,
  clearGuardianVerificationCache,
  guardianVerificationTimeoutRef,
}: UseGuardianVerificationLifecycleParams) => {
  useEffect(() => {
    if (signatureStep !== SessionNoteSignatures.ParentSignature) {
      setSelectedParentEmail('');
      clearGuardianVerificationCache();
    }
  }, [clearGuardianVerificationCache, setSelectedParentEmail, signatureStep]);

  useEffect(() => {
    return () => {
      if (guardianVerificationTimeoutRef.current) {
        window.clearTimeout(guardianVerificationTimeoutRef.current);
      }
    };
  }, [guardianVerificationTimeoutRef]);
};
